import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/portfolio.css'
import Helmet from '../components/Helmet/Helmet';

import favourite01 from '../assets/images/portfolio/favourite-01.jpg'
import favourite02 from '../assets/images/portfolio/favourite-02.jpg'
import favourite03 from '../assets/images/portfolio/favourite-03.jpg'
import favourite04 from '../assets/images/portfolio/favourite-04.jpg'
import favourite05 from '../assets/images/portfolio/favourite-05.jpg'
import favourite06 from '../assets/images/portfolio/favourite-06.jpg'
import favourite07 from '../assets/images/portfolio/favourite-07.jpg'
import favourite08 from '../assets/images/portfolio/favourite-08.jpg'
import favourite09 from '../assets/images/portfolio/favourite-09.jpg'
import favourite10 from '../assets/images/portfolio/favourite-10.jpg'
import favourite11 from '../assets/images/portfolio/favourite-11.jpg'
import favourite12 from '../assets/images/portfolio/favourite-12.jpg'
import favourite13 from '../assets/images/portfolio/favourite-13.jpg'
import favourite14 from '../assets/images/portfolio/favourite-14.jpg'
import favourite15 from '../assets/images/portfolio/favourite-15.jpg'
import favourite16 from '../assets/images/portfolio/favourite-16.jpg'

import monochrome01 from '../assets/images/portfolio/DSC0316.jpg'
import monochrome02 from '../assets/images/portfolio/bnw-02.jpg'
import monochrome03 from '../assets/images/portfolio/bnw-03.jpg'
import monochrome04 from '../assets/images/portfolio/bnw-04.jpg'
import monochrome05 from '../assets/images/portfolio/bnw-05.jpg'
import monochrome06 from '../assets/images/portfolio/bnw-06.jpg'
import monochrome08 from '../assets/images/portfolio/bnw-08.jpg'
import monochrome09 from '../assets/images/portfolio/bnw-09.jpg'
import monochrome10 from '../assets/images/portfolio/bnw-10.jpg'
import monochrome11 from '../assets/images/portfolio/bnw-11.jpg'
import monochrome12 from '../assets/images/portfolio/bnw-12.jpg'
import monochrome13 from '../assets/images/portfolio/bnw-13.jpg'
import monochrome14 from '../assets/images/portfolio/bnw-14.jpg'
import monochrome15 from '../assets/images/portfolio/bnw-15.jpg'

import animalPotrait01 from '../assets/images/portfolio/animal-portrait-01.jpg'
import animalPotrait02 from '../assets/images/portfolio/animal-portrait-02.jpg'
import animalPotrait03 from '../assets/images/portfolio/animal-portrait-03.jpg'
import animalPotrait04 from '../assets/images/portfolio/animal-portrait-04.jpg'
import animalPotrait05 from '../assets/images/portfolio/animal-portrait-05.jpg'
import animalPotrait06 from '../assets/images/portfolio/animal-portrait-06.jpg'
import animalPotrait07 from '../assets/images/portfolio/animal-portrait-07.jpg'
import animalPotrait08 from '../assets/images/portfolio/animal-portrait-08.jpg'
import animalPotrait09 from '../assets/images/portfolio/animal-portrait-09.jpg'
import animalPotrait10 from '../assets/images/portfolio/animal-portrait-10.jpg'
import animalPotrait11 from '../assets/images/portfolio/animal-portrait-11.jpg'
import animalPotrait12 from '../assets/images/portfolio/animal-portrait-12.jpg'

import goldenMoments1 from '../assets/images/portfolio/DSC_1584-2.jpg'
import goldenMoments2 from '../assets/images/portfolio/golden-moments-02.jpg'
import goldenMoments3 from '../assets/images/portfolio/golden-moments-03.jpg'
import goldenMoments4 from '../assets/images/portfolio/golden-moments-06-1.jpg'
import goldenMoments5 from '../assets/images/portfolio/golden-moments-04.jpg'
import goldenMoments6 from '../assets/images/portfolio/golden-moments-05.jpg'
import goldenMoments7 from '../assets/images/portfolio/golden-moments-07.jpg'
import goldenMoments8 from '../assets/images/portfolio/golden-moments-09.jpg'
import goldenMoments9 from '../assets/images/portfolio/golden-moments-10.jpg'
import goldenMoments10 from '../assets/images/portfolio/golden-moments-08.jpg'

const Portfolio = () => {

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const categoryFromUrl = query.get('category') || 'all';

  const [selectedCategory, setSelectedCategory] = useState(categoryFromUrl);

  useEffect(() => {
    setSelectedCategory(categoryFromUrl);
  }, [categoryFromUrl]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };


  // Sample image data for each category
  const imageData = {
    all: [
    ],
    favourites: [
        favourite01,
        favourite02,
        favourite03,
        favourite04,
        favourite05,
        favourite06,
        favourite07,
        favourite08,
        favourite09,
        favourite10,
        favourite11,
        favourite12,
        favourite13,
        favourite14,
        favourite15,
        favourite16
    ],
    monochrome: [
        monochrome01,
        monochrome02,
        monochrome03,
        monochrome04,
        monochrome05,
        monochrome06,
        monochrome08,
        monochrome09,
        monochrome10,
        monochrome11,
        monochrome12,
        monochrome13,
        monochrome14,
        monochrome15
    ],
    animalportrait: [
        animalPotrait01,
        animalPotrait02,
        animalPotrait03,
        animalPotrait04,
        animalPotrait05,
        animalPotrait06,
        animalPotrait07,
        animalPotrait08,
        animalPotrait09,
        animalPotrait10,
        animalPotrait11,
        animalPotrait12
    ],
    goldenmoments: [
        goldenMoments1,
        goldenMoments2,
        goldenMoments3,
        goldenMoments4,
        goldenMoments5,
        goldenMoments6,
        goldenMoments7,
        goldenMoments8,
        goldenMoments9,
        goldenMoments10,
    ]
  };

  function shuffleArray(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {

        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}

for (let category in imageData) {
    if (category !== "all") {
        imageData[category] = shuffleArray(imageData[category]);
        imageData.all = imageData.all.concat(imageData[category]);
    }
}

const getItemClass = (index) => {
  // Logic to determine item size class
  if (index % 3 === 0) return 'item--large';
  if (index % 3 === 1) return 'item--medium';
  return 'item--small';
};

const [modalImage, setModalImage] = useState(null);

const handleImageClick = (image) => {
  setModalImage(image);
};

const handleCloseModal = () => {
  setModalImage(null);
};

  return (
    <Helmet title={'Portfolio'}>
    <section className='portfolio __black'>
      <div className="w-1">
          <h1 className='__h1 e'>Portfolio</h1>
      </div>
      <div className="w-1">
        <div className='portfolio__gallery-menu'>
            <span className={`portfolio__gallery-categories ${selectedCategory === 'all' ? 'selected' : ''}`} onClick={() => handleCategoryClick('all')}>All</span>
            <span className={`portfolio__gallery-categories ${selectedCategory === 'favourites' ? 'selected' : ''}`} onClick={() => handleCategoryClick('favourites')}>favourite</span>
            <span className={`portfolio__gallery-categories ${selectedCategory === 'monochrome' ? 'selected' : ''}`} onClick={() => handleCategoryClick('monochrome')}>Monochrome</span>
            <span className={`portfolio__gallery-categories ${selectedCategory === 'animalportrait' ? 'selected' : ''}`} onClick={() => handleCategoryClick('animalportrait')}>Animal portrait</span>
            <span className={`portfolio__gallery-categories ${selectedCategory === 'goldenmoments' ? 'selected' : ''}`} onClick={() => handleCategoryClick('goldenmoments')}>Golden Moments</span>
        </div>
      </div>
      <div className="portfolio__gallery">
        {imageData[selectedCategory].map((image, index) => (
          <div className={`portfolio__gallery-item ${getItemClass(index)}`} key={index}>
            <img 
            key={index}
            className='portfolio__gallery-img' 
            src={image} alt={`gallery ${index + 1}`}
            onClick={() => handleImageClick(image)} 
            />
          </div>
        ))}
      </div>
      {modalImage && (
        <div className="modal" onClick={handleCloseModal}>
          <span className="modal__close">&times;</span>
          <img className="modal__content" src={modalImage} alt="Modal" />
        </div>
      )}
    </section>
    </Helmet>
  );
};

export default Portfolio;
